module.exports = __webpack_public_path__ + "static/media/farm_sprite.aab29c37.png";